import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/twoFactorAuth'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { Row, Col } from 'reactstrap'
import { Button } from '@/components/button'
import { WhiteBox } from '@/components/Layout'
import { Icon } from '@/components/Icon'
import Resx from '@/components/Resx'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'

const ProviderInfo = ({ provider }) => <div>{provider.providerName === 'Email' ? <Icon name={'envelope'} /> : <Icon name={'mobile'} />} {provider.providerName}{provider.contact && <span> ({provider.contact})</span>} </div>

const TwoFactor = ({ openDialog, twoFactorAuth, getTwoFactorInfo }) => {
  const openSetupDialog = useCallback(() => openDialog({ dialogType: dialogTypes.twoFactorSetup }), [openDialog])
  useEffect(() => {
    getTwoFactorInfo()
  }, [getTwoFactorInfo])
  const { fetching, twoFactor } = twoFactorAuth
  return (
    <WhiteBox header='Security.TwoFactorAuthentication'>
      <Row>
        <Col>
          {fetching && <LoadingIndicator />}
          {!fetching && twoFactor && <div className='flex twofactor'>
            <div>
              {twoFactor.isTwoFactorRequiredByPolicy && <div><Resx name='Security.TwoFactorIsRequiredByPolicy' /></div>}
              {!twoFactor.isTwoFactorRequiredByPolicy && <div><Resx name={twoFactor.isTwoFactorRequired ? 'Security.TwoFactorIsEnabled' : 'Security.TwoFactorIsDisabled'} /></div>}
              <label><Resx name='Security.AvailableProviders' /></label>
              {twoFactor.availableTwoFactorProviders.map((provider, idx) => <ProviderInfo key={idx} provider={provider} />)}
              {(twoFactor.isTwoFactorRequiredByPolicy || twoFactor.isTwoFactorRequired) && <React.Fragment>
                <label><Resx name='Security.PreferredTwoFactorProvider' /></label>
                <ProviderInfo provider={twoFactor.preferredTwoFactorProvider} />
              </React.Fragment>}
            </div>
            <Button disabled={fetching} color='primary' onClick={openSetupDialog}><Icon name='key' /><Resx name='Security.Setup' /></Button>
          </div>}
        </Col>
      </Row>
    </WhiteBox>
  )
}

const mapStateToProps = (state, ownProps) => ({
  twoFactorAuth: state.twoFactorAuth,
  ...ownProps
})

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog,
  getTwoFactorInfo: actionCreators.getTwoFactorInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactor)



// WEBPACK FOOTER //
// ./src/components/userProfile/twoFactor/index.js